import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { LocalAtm as LocalAtmIcon, ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import GridContainer from "../../components/Grid/GridContainer.js";
import GridItem from "../../components/Grid/GridItem.js";
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";
import Card from "../../components/Card/Card.js";
import CardHeader from "../../components/Card/CardHeader.js";
import CardIcon from "../../components/Card/CardIcon.js";
import CardBody from "../../components/Card/CardBody.js";
import Snackbars from "../../components/Snackbar/Snackbar.js";
import { convertToMapById } from "../../helpers/convertToMap";
import { useColorTheme } from "../../hooks/useColorTheme";
import { useForm } from "../../hooks/useForm";
import {
  editBrandSaleV2,
  addNewBrandSaleV2,
} from "../../redux/actions/brands/brandsAction_V2";
import { TitleWrapperStyled, TitleStyled, styles } from "./styles";

const useStyles = makeStyles(styles);

function NewBrandSales() {
  const { isEdit, id } = useParams();
  const dispatch = useDispatch();
  const colorBg = useSelector((state) => state.config.colorBg);
  const { token } = useSelector((state) => state.login);
  const { stations } = useSelector((state) => state.companies);
  const { brandName, brandSales } = useSelector((state) => state.brandsReducer);
  const { color } = useColorTheme(colorBg);
  const classes = useStyles();
  let history = useHistory();

  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    cellphone: "",
    url: "",
    whatsapp: "",
    idBrand: "",
    idStation: "",
  });

  const { cellphone, url, whatsapp, idBrand, idStation } = inputValues;
  const [mapStations, setMapStations] = useState([]);
  const [mapBrands, setMapBrands] = useState([]);
  const [handleError, setHandleError] = useState({
    isError: false,
    errorMessage: "",
  });
  const { isError, errorMessage } = handleError;

  const handleCloseError = () => {
    setHandleError({ isError: false, errorMessage: "" });
  };

  useEffect(() => {
    setMapStations(convertToMapById(stations));
  }, [stations]);

  useEffect(() => {
    setMapBrands(convertToMapById(brandName));
  }, [brandName]);

  useEffect(() => {
    isEdit && id && handleNewValues({ ...brandSales[id] });
  }, [brandSales]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setHandleError({ isError: false, errorMessage: "" });
    let errors = [];
    if (cellphone.length === 0 || cellphone.length > 10) {
      errors.push("Celular es requerido, longitud maxima 10 dígitos *");
    }
    if (idBrand.length === 0) {
      errors.push(" WhatsApp requerido *");
    }
    if (idStation.length === 0) {
      errors.push(" Url requerido *");
    }
    if (idBrand.length === 0) {
      errors.push(" Marca requerida *");
    }
    if (idStation.length === 0) {
      errors.push(" Planta requerida *");
    }

    const body = { cellphone, whatsapp, url, idStation, idBrand };
    const bodyEdit = { cellphone, whatsapp, url };

    if (errors.length === 0) {
      isEdit
        ? dispatch(editBrandSaleV2(id, bodyEdit, token))
        : dispatch(addNewBrandSaleV2(body, token));
      setTimeout(() => {
        history.push("/admin/marcas");
      }, 600);
    } else {
      setHandleError({
        isError: true,
        errorMessage: `${errors.map((err) => `${err} \n`)}`,
      });
    }
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color={color} icon>
              <CardIcon color={color}>
                <LocalAtmIcon />
              </CardIcon>
              <TitleWrapperStyled>
                <TitleStyled>
                  {isEdit ? "Editar marca venta" : "Nueva marca venta"}
                </TitleStyled>
                <Button
                  justIcon
                  round
                  color={color}
                  onClick={handleGoBack}
                >
                  <ArrowBackIcon className={classes.buttonIcon} />
                </Button>
              </TitleWrapperStyled>
            </CardHeader>
            <CardBody>
              <form>
                <CustomInput
                  required
                  labelText="Celular *"
                  id="cellphone"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    onChange: handleInputOnChange,
                    type: "text",
                    value: cellphone,
                    name: "cellphone",
                  }}
                />
                <CustomInput
                  labelText="WhatsApp"
                  id="whatsapp"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    onChange: handleInputOnChange,
                    type: "text",
                    value: whatsapp,
                    name: "whatsapp",
                  }}
                />
                <CustomInput
                  id="url"
                  labelText="Url"
                  formControlProps={{ fullWidth: true }}
                  inputProps={{
                    onChange: handleInputOnChange,
                    type: "text",
                    value: url,
                    name: "url",
                  }}
                />

                <InputLabel
                  htmlFor="simple-select"
                  className={classes.selectLabel}
                >
                  Marca*
                </InputLabel>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <Select
                    MenuProps={{ className: classes.selectMenu }}
                    classes={{ select: classes.select }}
                    value={idBrand}
                    disabled={Boolean(isEdit)}
                    onChange={handleInputOnChange}
                    inputProps={{ name: "idBrand", id: "id_brand" }}
                  >
                    {mapBrands &&
                      mapBrands.map((value) => (
                        <MenuItem
                          key={value.id}
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value={value.id}
                        >
                          {value.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <InputLabel
                  htmlFor="simple-select"
                  className={classes.selectLabel}
                >
                  Planta *
                </InputLabel>
                <FormControl fullWidth className={classes.selectFormControl}>
                  <Select
                    MenuProps={{ className: classes.selectMenu }}
                    classes={{ select: classes.select }}
                    value={idStation}
                    disabled={Boolean(isEdit)}
                    onChange={handleInputOnChange}
                    inputProps={{ name: "idStation", id: "id_station" }}
                  >
                    {mapStations &&
                      mapStations.map((value) => (
                        <MenuItem
                          key={value.id}
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value={value.id}
                        >
                          {value.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>

                <div className={classes.formCategory}>
                  <small>*</small> Campos requeridos
                </div>

                <Button
                  color={color}
                  onClick={handleSubmit}
                  className={classes.registerButton}
                  type="submit"
                >
                  Guardar
                </Button>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <Snackbars
        place="tr"
        color="danger"
        message={errorMessage}
        open={isError}
        closeNotification={handleCloseError}
        close
      />
    </React.Fragment>
  );
}

export default React.memo(NewBrandSales);
